import * as $ from 'jquery';

import Debouncer from '../../lib/Debouncer';
import DetectBrowser from '../../lib/DetectBrowser';
import ViewportTracker from '../../lib/ViewportTracker';

// Load to ensure our easing functions are registered with jQuery
import '../../lib/AnimationEasing';

import SearchForm from './MainMenuSearch';
new SearchForm('.menuSearchForm', '.menuSearchForm button', '.menuSearchForm [type="text"]', 'open');

export interface MainMenuConfig {
	[key: string]: any
}
export default class MainMenu {
	private initialSetup = false;
	private menuActive = false;
	private animationUnsupported = false;

	private $menu: JQuery;
	private $menuTarget: JQuery;

	constructor(private config: MainMenuConfig) {
		let browserInfo = DetectBrowser.getInfo();

		this.animationUnsupported = browserInfo.android && browserInfo.android.browserVersion === 4.0;

		this.$menu = $(config.menu);
		this.$menuTarget = this.$menu.find(config.menuTarget);

		const resizeDebouncer = new Debouncer(() => {
			// Close menu on resize.
			this.toggleMenu(false);

			this.syncMobileMenuToViewport();
		});
		window.addEventListener('resize', resizeDebouncer.run);

		this.syncMobileMenuToViewport();
	}
	private syncMobileMenuToViewport() {
		// Turn mobile menu on/off based on size
		if (ViewportTracker.below('mobileMenu', true)) {
			this.turnOn();
		} else {
			this.turnOff();
		}
	}
	turnOn() {
		this.menuActive = true;

		if (this.initialSetup === false) {
			this.$menu.addClass(this.config.styleClass.setup);

			// Open current and close the other ones
			var $nodeTriggers = this.$menu.find(this.config.nodeTrigger);
			this.openNode($nodeTriggers.not('.isActive').parent(), false);
			this.openNode($nodeTriggers.filter('.isActive').parent(), true);

			// Open/close menu handler
			$(this.config.triggers).on(this.config.triggerEvent, (event) => {
				if (this.menuActive === false)
					return;
				event.preventDefault();

				this.toggleMenu();
			});

			// Open/close node handler
			this.$menu.on('click.mobileMenu', this.config.nodeTrigger, (event) => {
				if (this.menuActive === false)
					return;
				event.preventDefault();

				var $anchor = event.target.tagName !== 'A' ? $(event.target).parent('A') : $(event.target);
				var $listItem = $anchor.parent('li');

				this.openNode($listItem, !this.isNodeOpen($listItem));
			});

			this.initialSetup = true;
		}
	}
	turnOff() {
		this.menuActive = false;
	}
	toggleMenu(forceOpen?: boolean) {
		this.$menu.toggleClass(this.config.styleClass.menuOpen, forceOpen);
	}
	isNodeOpen($listItem: JQuery) {
		return $listItem.hasClass(this.config.styleClass.nodeOpen);
	}
	openNode($listItem: JQuery, open: boolean) {
		if (this.menuActive === false) {
			return;
		}
		if (this.config.onNodeChange !== undefined) {
			var ifContinue = this.config.onNodeChange($listItem, open);
			if (ifContinue === false) {
				return;
			}
		}
		if (this.config.hideSiblingMenuItems !== undefined) {
			if ($listItem.filter(this.config.hideSiblingMenuItems).length > 0) {
				this.slideToggle($listItem.siblings(this.config.hideSiblingMenuItems), this.config.collapsable.duration, 'easeOutExpo', !open);
			}
		}
		this.openNodeHelper($listItem, open);
	}
	openNodeHelper($listItem: JQuery, open: boolean) {
		$listItem.toggleClass(this.config.styleClass.nodeOpen, open);

		if (this.config.collapsable !== undefined) {
			var $elementSlide = $listItem.children('div');

			var duration = (this.animationUnsupported ? 0 : this.config.collapsable.duration);
			this.slideToggle($elementSlide, duration, 'easeOutExpo', open);
		}
	}
	slideToggle($element: JQuery, duration: number, ease: string, open: boolean) {
		$element.stop();

		if (open === true) {
			$element.slideDown(duration, ease);
		} else {
			$element.slideUp(duration, ease);
		}
	}
}